const TeamBuildIcon = () => {
  return (
    <svg
      width='224'
      height='142'
      viewBox='0 0 224 142'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M118.125 21.4738C104.024 18.1579 93.7564 21.3804 82.0283 25.4272C76.2473 27.4218 70.3953 29.5312 64.3033 30.3337C59.7562 30.9328 55.1626 31.0917 50.5984 31.5452C45.8532 32.0168 41.1099 32.6118 36.4527 33.6586C28.6071 35.4223 14.9424 38.6719 15.7807 49.2347C16.1164 53.4645 19.0039 57.3092 18.7124 61.5424C18.3386 66.9677 13.2771 71.1701 9.96118 75.0034C5.38394 80.2948 1.26754 86.1668 2.02255 93.5228C2.63131 99.4561 6.48499 104.67 11.2363 108.276C15.9875 111.881 21.6103 114.119 27.1503 116.329C35.5886 119.694 42.7244 123.635 49.3625 129.893C53.2078 133.518 57.3021 137.11 62.286 138.867C68.983 141.228 77.5207 139.173 80.2479 132.081C81.7345 128.215 82.1525 123.714 84.4583 120.202C86.8334 116.584 91.8414 113.539 96.2593 114.125C103.455 115.079 106.261 120.417 109.691 126.032C111.366 128.774 113.354 131.299 116.167 132.945C120.993 135.769 125.814 134.668 130.901 133.522C136.398 132.285 141.951 131.284 147.546 130.615C157.039 129.481 166.59 129.989 176.049 131.182C185.031 132.315 198.073 138.221 205.481 130.206C208.726 126.695 209.373 121.887 208.191 117.402C206.497 110.975 202.852 103.839 203.049 97.1636C203.339 87.3084 207.781 80.7486 213.211 73.0479C215.811 69.3605 217.814 65.2632 217.72 60.6498C217.505 50.0355 210.851 41.8861 203.913 34.5679C196.99 27.2658 190.074 18.9457 183.07 12.4709'
        stroke='#ED725A'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M218.961 32.3117C218.961 33.8539 217.711 35.1038 216.169 35.1038C214.627 35.1038 213.377 33.8539 213.377 32.3117C213.377 30.7696 214.627 29.5196 216.169 29.5196C217.711 29.5196 218.961 30.7696 218.961 32.3117Z'
        stroke='#ED725A'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M125.483 126.848C125.483 128.39 124.233 129.64 122.691 129.64C121.148 129.64 119.898 128.39 119.898 126.848C119.898 125.306 121.149 124.056 122.691 124.056C124.233 124.056 125.483 125.306 125.483 126.848Z'
        stroke='#ED725A'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M115.731 5.27165C116.89 5.27165 117.83 6.2114 117.83 7.37035V48.8633C117.83 50.0226 116.89 50.962 115.731 50.962H35.1983C34.0391 50.962 33.0997 50.0223 33.0997 48.8633V7.37035C33.0997 6.2114 34.0394 5.27165 35.1983 5.27165H115.731ZM115.731 4.76965H35.1983C33.7643 4.76965 32.5977 5.9363 32.5977 7.37035V48.8633C32.5977 50.2974 33.7643 51.464 35.1983 51.464H115.731C117.165 51.464 118.332 50.2974 118.332 48.8633V7.37035C118.332 5.9363 117.165 4.76965 115.731 4.76965Z'
        fill='white'
      />
      <path
        d='M115.731 50.9622H35.1983C34.039 50.9622 33.0996 50.0225 33.0996 48.8635V10.8685H117.83V48.8635C117.83 50.0228 116.89 50.9622 115.731 50.9622Z'
        fill='#AFB9E8'
      />
      <path
        d='M38.0282 8.23414C38.0282 8.89745 37.4904 9.43526 36.8271 9.43526C36.1638 9.43526 35.626 8.89745 35.626 8.23414C35.626 7.57083 36.1638 7.03302 36.8271 7.03302C37.4904 7.03302 38.0282 7.57083 38.0282 8.23414Z'
        stroke='white'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M42.6845 8.23414C42.6845 8.89745 42.1467 9.43526 41.4833 9.43526C40.82 9.43526 40.2822 8.89745 40.2822 8.23414C40.2822 7.57083 40.82 7.03302 41.4833 7.03302C42.1467 7.03302 42.6845 7.57083 42.6845 8.23414Z'
        stroke='white'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path d='M33.0996 10.8685H117.83' stroke='white' strokeWidth='0.502' stroke-miterlimit='10' />
      <path
        d='M111.017 45.1435C110.165 44.014 108.711 42.9745 107.576 43.7523C106.624 44.4049 106.588 45.8784 106.662 47.1033C103.961 43.2801 100.748 39.8889 97.1559 37.071C95.2095 35.5442 92.9725 34.1329 90.5817 34.317C88.1908 34.5011 86.9506 37.8561 87.5791 40.3805C81.051 31.7364 73.7707 25.605 66.1888 20.2995C63.6012 18.489 60.7297 16.743 57.6599 15.7109C54.3945 14.6128 49.8839 13.326 46.9334 15.8755C45.6694 16.9679 45.0108 18.6345 44.8314 20.2955C44.6095 22.3513 44.9572 24.5223 45.5175 26.5032C46.8575 31.2418 49.0067 35.7096 51.4996 39.9183C53.9936 44.1284 59.4791 51.0423 59.4791 51.0423H113.614C113.199 48.8867 112.3 46.8439 111.017 45.1435Z'
        fill='#909DF4'
      />
      <path
        d='M82.5495 42.5723C82.5495 42.5723 72.1564 33.5587 67.6986 32.0303C63.2409 30.5019 54.0811 32.957 53.9663 32.957C53.8511 32.957 45.7666 50.9634 45.7666 50.9634H78.924L82.5495 42.5723Z'
        fill='#EF9748'
      />
      <path
        d='M102.294 67.0433C103.052 67.8341 103.84 68.5962 104.655 69.3281C105.441 70.0342 106.303 70.6641 107.07 71.3866C107.259 71.565 107.432 71.7601 107.604 71.9549C108.231 72.6644 108.863 73.3816 109.32 74.2112C109.381 74.3217 109.44 74.4361 109.532 74.5228C109.623 74.6095 109.756 74.6644 109.877 74.6282C110.003 74.5907 110.082 74.4686 110.136 74.3488C110.356 73.8514 110.302 73.2745 110.166 72.7474C110.08 72.408 109.961 72.0781 109.866 71.741C109.788 71.4619 109.673 71.1614 109.715 70.8719C111.942 71.802 113.753 73.4877 115.783 74.7915C116.199 75.0586 117.115 75.158 117.269 74.7905C117.473 74.3043 114.511 72.1095 113.154 70.6587C114.177 71.1815 115.262 71.7287 116.185 72.4164C116.825 72.893 117.524 73.2996 118.287 73.5422C118.715 73.6784 119.699 73.8802 119.498 73.0978C119.439 72.8669 119.265 72.6855 119.095 72.5195C117.768 71.232 116.168 70.3224 114.774 69.1082C116.343 69.727 117.783 70.8358 119.468 70.894C119.632 70.8997 119.81 70.8907 119.939 70.7896C120.136 70.636 120.202 70.4221 120.074 70.2076C119.946 69.9931 119.724 69.8545 119.511 69.724C117.947 68.7672 116.318 67.71 114.754 66.7532C115.595 66.9814 116.373 67.3934 117.178 67.7254C117.984 68.0574 118.853 68.3141 119.718 68.2063C119.996 68.1715 120.342 67.9924 120.279 67.7194C120.248 67.5872 120.128 67.4985 120.016 67.4222C118.115 66.1227 116.214 64.8231 114.314 63.524C113.78 63.1595 113.247 62.7947 112.7 62.4507C112.042 62.0364 111.282 61.7288 110.67 61.2626C110.193 60.8988 109.616 60.6288 109.104 60.3142C107.839 59.5371 106.614 58.6991 105.426 57.8085'
        fill='#FFCAA3'
      />
      <path
        d='M109.757 70.8653C109.159 70.6019 108.551 70.3596 107.936 70.1387'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M113.243 70.6549C112.431 70.0993 111.59 69.5863 110.725 69.1191'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M114.778 69.0762C114.111 68.6535 113.444 68.2308 112.777 67.8081'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M115.513 67.1676C115.016 66.8942 114.538 66.587 114.083 66.249'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M70.0918 32.3107C74.1972 33.6011 76.2574 33.7189 79.93 35.9977C83.8329 38.419 93.4877 48.5922 93.4877 48.5922C93.4877 48.5922 106.516 57.7775 111.399 61.2506L102.627 69.6109C92.9258 63.8112 82.9674 56.8872 75.6131 48.3037'
        fill='#EF9748'
      />
      <path
        d='M55.1963 49.2166C55.1963 49.2166 59.2678 47.0329 61.0596 46.5821C63.5415 45.958 66.4853 45.7816 67.2744 46.0219C67.6439 46.1343 69.0344 46.7056 69.762 47.5567C70.5347 47.8947 70.8486 48.064 71.3075 48.2571C71.7663 48.4502 71.9818 48.9904 72.4624 49.402C72.9427 49.8137 73.4701 50.9602 73.4701 50.9602C73.4701 50.9602 69.8062 50.9726 68.7771 51.0068C67.7476 51.0409 66.6362 53.0061 64.3334 53.7022'
        fill='#FFCAA3'
      />
      <path
        d='M63.5849 30.6912C60.7603 30.6685 58.0097 29.9325 55.1908 29.9308C50.0707 29.9278 47.132 32.6139 44.6414 36.337C42.7556 39.1563 40.9798 42.6258 39.6435 45.7211C38.0839 49.3342 36.337 53.3575 35.8818 57.3032C35.6737 59.1081 35.933 60.9722 36.7674 62.5762C38.3112 65.5437 41.7415 66.0621 43.7425 66.2843C45.7435 66.5069 49.2498 65.8309 50.9669 64.766C60.0053 59.1616 65.9814 53.5449 65.9814 53.5449L56.258 48.5607L51.5934 50.386L57.4842 39.496'
        fill='#EF9748'
      />
      <path
        d='M57.006 40.3795L51.5938 50.386'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M56.2581 48.5607C53.47 49.6427 50.6816 50.7243 47.8935 51.8063C45.9899 52.5449 44.1238 54.0064 42.6074 55.3652'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M52.918 49.9199L62.9914 56.1186'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M79.9938 45.0698C78.6602 47.2746 76.8135 50.9606 76.8135 50.9606'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M107.843 58.7291L98.0703 66.8688'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M69.3857 48.6009C70.0942 48.789 70.8151 48.9312 71.542 49.0266C71.7666 49.056 72.0005 49.0842 72.1906 49.207'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M70.0117 47.748C69.8859 47.6848 69.7534 47.6362 69.6208 47.5877C68.9194 47.33 68.1972 47.0686 67.4502 47.0881'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M67.7344 51.4147C68.1136 51.1416 68.5821 51.0177 69.0466 50.9696C70.0111 50.8695 71.0436 51.0773 71.9692 50.7145'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M31.5117 58.0018C31.668 61.8156 34.1017 65.4488 37.5692 67.0448'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M28.8125 57.837C28.8915 60.3256 29.9189 62.7372 31.5119 64.1726'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M83.6562 33.696C86.6301 36.213 89.3924 38.9804 91.9041 41.9589'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M83.7227 30.7114C85.7966 32.2515 87.6975 34.0246 89.3775 35.9867'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M59.7105 35.767C58.1389 35.2024 56.6828 34.3624 55.2457 33.512C54.6363 33.1513 54.0205 32.7818 53.5285 32.2721C53.0366 31.7624 52.6748 31.088 52.6889 30.3799C52.7019 29.7273 53.0286 29.1185 53.4345 28.6072C54.7009 27.0121 56.7477 26.1842 58.7758 26.0001C60.8039 25.816 62.8386 26.2076 64.8209 26.6755C67.8004 27.3786 70.8422 28.3133 73.141 30.335C73.7879 30.9043 74.3736 31.5639 74.735 32.3464C75.234 33.427 75.2708 34.675 75.0577 35.846C74.8445 37.017 74.3953 38.1298 73.9492 39.2332'
        fill='#EF9748'
      />
      <path
        d='M67.7712 23.9954L63.7646 25.1627L63.8543 27.1771L61.8262 30.6372C61.8262 30.6372 66.6203 32.494 68.4228 36.28C70.3863 36.5719 71.1724 34.9802 71.1724 34.9802L73.1028 30.3548'
        fill='#FFCAA3'
      />
      <path
        d='M77.1991 28.0153C77.5444 26.0291 77.9604 23.8802 77.928 22.2986C77.9005 20.9596 77.6957 18.9375 76.8309 17.8887C75.7178 16.5379 73.6907 16.5162 71.9893 16.3264C69.1955 16.0152 67.2648 18.5459 66.4378 20.91C65.8027 22.7263 65.8549 24.499 66.4432 26.3711C67.2123 28.8179 69.9391 32.1043 73.4873 31.701C75.3701 31.4872 76.8333 30.1187 77.1991 28.0153Z'
        fill='#FFCAA3'
      />
      <path
        d='M73.7709 23.675C73.7368 23.9706 73.5259 24.1891 73.2997 24.163C73.0734 24.1369 72.9178 23.8762 72.952 23.5803C72.9861 23.2848 73.1973 23.0663 73.4232 23.0924C73.6494 23.1185 73.805 23.3792 73.7709 23.675Z'
        fill='black'
      />
      <path
        d='M77.6371 24.0417C77.603 24.3373 77.3918 24.5558 77.1659 24.5297C76.9396 24.5036 76.784 24.2429 76.8182 23.947C76.8523 23.6515 77.0635 23.433 77.2894 23.4591C77.5156 23.4855 77.6712 23.7462 77.6371 24.0417Z'
        fill='black'
      />
      <path
        d='M75.9228 23.3876C75.8368 24.072 75.9074 24.7675 75.9087 25.4542C75.9097 25.8792 75.9248 26.6279 75.3726 26.7243C75.0105 26.7875 74.2217 26.5717 74.2217 26.5717'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M74.5305 27.7856L73.082 26.5661C73.082 26.5661 72.0184 27.9563 72.5676 28.46C73.4552 29.2742 74.5305 27.7856 74.5305 27.7856Z'
        fill='white'
      />
      <path
        d='M76.8821 18.3115C77.521 19.3112 77.8737 20.1154 77.9009 23.1143C78.2067 23.038 78.5166 22.96 78.7914 22.8058C79.0662 22.6515 79.3064 22.4089 79.3871 22.1043C79.5367 21.5401 79.1164 20.9818 79.0933 20.3985C79.0765 19.9772 79.2693 19.5752 79.4982 19.2208C79.6742 18.9481 79.8804 18.6763 79.9226 18.3544C79.9821 17.9009 79.698 17.4698 79.3593 17.1623C78.603 16.4759 77.5893 16.2025 76.7205 15.6988C76.2995 15.4548 76.0756 15.0736 75.6847 14.7872C75.2433 14.4635 74.7714 14.1817 74.2774 13.9461C73.1379 13.402 71.8876 13.1081 70.6272 13.0546C68.1848 12.9502 65.7719 13.8621 64.0691 15.5683C61.8181 17.8243 60.9145 22.1267 62.3268 24.6183C63.123 26.0226 63.8539 27.1765 63.8539 27.1765C63.9443 27.3201 65.892 25.5715 66.0115 25.3338C66.1323 25.0929 66.1778 24.8228 66.2518 24.5634C66.5038 23.6796 67.3826 23.5313 68.136 23.2552C69.2347 22.853 69.7842 21.8747 69.997 20.7707C70.1195 20.1361 70.1376 19.4862 70.1553 18.8403C70.1516 18.9849 71.0395 19.2968 71.1724 19.338C72.4823 19.7419 73.9625 19.8132 75.2921 19.4554C75.6847 19.35 76.103 19.2148 76.4133 18.9467C76.4983 18.8734 77.0234 18.4554 76.8821 18.3115Z'
        fill='#1E1611'
      />
      <path
        d='M68.6973 29.9274C68.7672 29.9783 70.1581 31.4974 72.8187 31.735'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M71.4268 21.5721C71.6634 21.1086 72.1369 20.7739 72.6533 20.7063C73.1694 20.6387 73.7132 20.8398 74.0616 21.2267'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M76.3447 21.6363C76.5204 21.2438 76.8926 20.9931 77.2175 21.0486C77.5425 21.1042 77.7878 21.465 77.8079 21.8856'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M75.1629 24.4359C74.8245 25.4419 73.7542 25.9763 72.7727 25.6296C71.7911 25.2829 71.2697 24.1859 71.608 23.1799C71.9464 22.1739 73.0166 21.6394 73.9982 21.9861C74.9798 22.3328 75.5012 23.4299 75.1629 24.4359Z'
        stroke='#572A2F'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M78.7703 24.9069C78.5883 25.9548 77.9129 26.7078 77.2616 26.589C76.6104 26.4702 76.2299 25.5244 76.4116 24.4769C76.5936 23.4291 77.269 22.6761 77.9203 22.7949C78.5718 22.9137 78.9524 23.8591 78.7703 24.9069Z'
        stroke='#572A2F'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M76.5843 23.9202L75.2617 23.6725'
        stroke='#572A2F'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M71.6834 22.9905L67.6992 23.2947'
        stroke='#572A2F'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M68.8379 24.0138C68.8181 23.0479 67.5146 22.2906 66.6572 22.5985C64.5957 23.3387 65.2901 27.0308 67.2057 27.3849C67.7475 27.4849 68.5256 27.2717 68.7174 26.658'
        fill='#FFCAA3'
      />
      <path
        d='M66.5078 24.2447L68.2795 25.8498'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M67.9277 22.8232C68.3591 23.0829 68.7092 23.4818 68.9173 23.9523'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M65.4775 25.6431C65.7433 26.4325 66.2858 27.2682 67.1445 27.4104C67.7406 27.5092 68.4233 27.2481 68.6672 26.6297'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M60.9277 20.2076C60.9679 18.9084 61.1105 17.5995 61.5331 16.3703C61.9558 15.1411 62.676 13.9888 63.7152 13.208C64.2905 12.776 64.9481 12.4668 65.6134 12.1933C66.1736 11.9631 66.7459 11.7556 67.3386 11.6294C69.5591 11.1569 71.859 11.8593 73.9389 12.769'
        fill='#FFC36C'
      />
      <path
        d='M74.9332 12.9471C74.385 12.4187 73.6759 12.0773 72.9383 11.8882C72.4985 11.7755 72.0437 11.7142 71.5906 11.7366C71.355 11.7484 71.1207 11.7828 70.8891 11.8283C69.2797 12.1449 67.8289 12.9893 66.434 13.8524C64.5713 15.005 62.7119 16.2456 61.3458 17.9578C60.8525 18.5759 60.4161 19.2891 60.3719 20.0785C60.3474 20.516 60.4462 20.952 60.5894 21.3663C60.831 22.0648 61.399 23.0611 61.8745 23.627C65.9712 19.7947 70.5725 16.763 75.885 14.9618C75.8572 14.2011 75.4814 13.4756 74.9332 12.9471Z'
        fill='#FFC36C'
      />
      <path
        d='M61.1934 18.156C61.1934 18.156 64.6518 13.3344 71.071 11.7321'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M62.9902 18.7008C63.4966 19.5763 64.0157 20.4675 64.7697 21.1419'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M67.0322 15.0763C67.5566 16.1814 68.2076 17.2305 68.9693 18.1974'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M71.3184 12.7728C72.2025 13.6841 72.9586 14.7195 73.5569 15.8397'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M72.7969 12.2514C73.5566 13.1871 74.2226 14.2982 74.7185 15.3819'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M60.9805 19.2413C61.2288 20.6305 62.0417 21.8078 63.0792 22.6442'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M58.6143 29.3518C60.5724 30.0834 62.5503 30.8243 64.2925 31.9793C66.0352 33.1339 67.7995 34.7563 68.422 36.752'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M69.7783 36.1436C70.6699 35.7159 71.3941 34.9495 71.7706 34.0352'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M52.6885 30.1685C53.5941 35.3692 60.4548 34.3743 63.6505 35.9867'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M75.1753 33.9468C75.0501 34.661 74.8032 35.3731 74.3293 35.922C73.6171 36.7463 72.51 37.0876 71.4639 37.3908'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M72.4102 36.1438C72.8861 39.4145 73.3676 43.0798 73.2154 46.3813'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M65.1406 35.3923C65.6369 36.7514 65.4037 40.4364 65.3498 43.7607'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M98.3448 130.63H23.836C22.6767 130.63 21.7373 129.69 21.7373 128.531V78.0805H100.444V128.531C100.444 129.69 99.5038 130.63 98.3448 130.63Z'
        fill='#D4BCDD'
      />
      <path
        d='M98.3449 71.2792C99.5042 71.2792 100.444 72.2189 100.444 73.3779V128.531C100.444 129.69 99.5038 130.629 98.3449 130.629H23.836C22.6768 130.629 21.7374 129.69 21.7374 128.531V73.3779C21.7374 72.2186 22.6771 71.2792 23.836 71.2792H98.3449ZM98.3449 70.7772H23.836C22.402 70.7772 21.2354 71.9438 21.2354 73.3779V128.531C21.2354 129.965 22.402 131.131 23.836 131.131H98.3446C99.7786 131.131 100.945 129.965 100.945 128.531V73.3779C100.946 71.9438 99.7789 70.7772 98.3449 70.7772Z'
        fill='white'
      />
      <path
        d='M27.7276 74.8787C27.7276 75.6849 27.074 76.3385 26.2681 76.3385C25.4619 76.3385 24.8086 75.6849 24.8086 74.8787C24.8086 74.0725 25.4622 73.4193 26.2681 73.4193C27.074 73.4193 27.7276 74.0729 27.7276 74.8787Z'
        stroke='white'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M31.9243 76.3382C32.7304 76.3382 33.3838 75.6848 33.3838 74.8787C33.3838 74.0727 32.7304 73.4193 31.9243 73.4193C31.1183 73.4193 30.4648 74.0727 30.4648 74.8787C30.4648 75.6848 31.1183 76.3382 31.9243 76.3382Z'
        stroke='white'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M21.7373 78.0805H100.444'
        stroke='white'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M92.8817 130.629C91.8248 128.023 90.385 125.583 88.6264 123.416C87.5467 122.086 86.2921 120.822 84.7081 120.237C83.1241 119.652 81.1472 119.908 80.0703 121.24C79.2463 122.259 79.0897 123.667 78.9669 124.987C76.3578 122.187 73.7153 119.358 70.533 117.281C67.3506 115.203 63.4886 113.726 59.8035 114.534C55.7173 115.43 55.7173 120.594 55.7173 120.594C55.7173 120.594 53.2123 117.083 52.986 116.752C51.3107 114.302 49.4155 112.058 47.3985 109.902C45.4176 107.786 43.5337 105.56 41.3022 103.712C39.0783 101.871 35.4693 99.5205 32.4804 100.635C30.9255 101.214 30.4971 102.563 30.8422 104.119C31.1648 105.575 31.3348 107.033 31.7873 108.466C29.2736 105.665 26.4128 103.085 23.0966 101.341C20.7038 100.082 15.7112 97.9502 13.2276 100.011C12.5115 100.605 12.1862 101.59 12.1651 102.537C12.0349 108.334 16.2119 114.564 19.5773 118.847C23.03 123.242 27.1956 127.134 31.5091 130.629H92.8817Z'
        fill='#FFDD99'
      />
      <path
        d='M77.7586 104.439C77.3121 106.903 77.4446 109.45 77.4567 111.968C77.4687 114.486 77.6715 116.133 76.7606 118.419C75.9383 120.483 74.2208 121.184 73.3242 123.205C72.8677 124.234 71.1365 130.625 71.1365 130.625H47.8862C47.8862 130.625 47.2343 120.58 50.8196 112.007C54.4048 103.434 58.8867 101.897 58.8867 101.897L72.1144 98.4849L77.7586 104.439Z'
        fill='#735D9D'
      />
      <path
        d='M108.218 89.4514C108.908 88.6194 109.873 88.0973 110.699 87.4206C111.46 86.7971 112.029 85.9227 112.661 85.1673C113.433 84.2433 114.033 83.1921 114.703 82.1951C115.422 81.1252 116.344 80.2598 117.256 79.3592C117.382 79.234 117.512 79.1052 117.584 78.9425C117.714 78.6487 117.562 78.2625 117.225 78.1714C116.566 77.9937 115.863 78.1624 115.223 78.4017C114.843 78.5439 113.555 79.0001 113.477 78.2749C113.389 77.4553 114.075 76.2585 114.338 75.4988C114.679 74.5105 115.029 73.5199 115.307 72.5109C115.571 71.5497 115.511 69.7027 115 69.6726C114.489 69.6425 114.874 69.9487 114.741 70.021C114.955 69.7398 114.581 69.0909 114.274 68.8972C113.968 68.7034 113.569 69.3309 113.477 69.6692C113.582 69.3389 113.291 68.7931 113.046 68.7703C112.688 68.7372 112.411 69.0759 112.197 69.352C111.984 69.6281 111.795 69.9366 111.493 70.1214C111.496 69.8844 111.46 69.6468 111.388 69.4192C111.155 69.2874 110.888 69.5056 110.719 69.7044C107.293 73.7502 104.974 78.7668 101.173 82.6617'
        fill='#E27769'
      />
      <path
        d='M113.557 77.7189C113.569 78.7148 113.544 79.7111 113.481 80.7054'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M114.632 69.7837C114.333 70.7238 113.755 71.5183 113.321 72.3927C112.63 73.7846 112.012 75.2106 111.371 76.6256'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M113.453 69.5988C113.243 70.0386 113.005 70.4643 112.739 70.8719C112.454 71.309 112.138 71.725 111.833 72.148C110.96 73.3575 110.173 74.6289 109.479 75.9495'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M111.374 70.2719C111.144 70.7645 110.767 71.1705 110.411 71.5821C109.296 72.8713 108.337 74.2939 107.56 75.8103'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M65.4404 99.8176C69.6003 98.0767 72.3252 96.2487 76.4436 94.3937C80.1571 92.7213 85.3682 91.3495 89.0297 89.5644C94.0933 87.0959 98.8412 84.3694 103.003 80.6345L110.565 88.5952C110.565 88.5952 99.8793 99.496 96.1488 101.621C87.1586 106.742 83.8839 107.7 74.5387 112.588'
        fill='#735D9D'
      />
      <path
        d='M77.3496 111.219C77.4025 109.339 77.8312 107.47 78.6036 105.755'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M100.48 82.7271L107.98 91.1439'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M64.2301 122.896C67.4014 122.954 70.5594 123.455 73.3086 125.126C74.6289 125.928 75.3645 127.001 75.7283 128.491C76.0355 129.748 76.1349 131.094 76.0218 132.384C76.0111 132.506 75.9164 132.619 75.8109 132.644C75.662 132.68 75.3625 132.532 75.3625 132.532C75.3625 132.532 75.6329 133.811 75.3464 134.077C75.147 134.262 74.7705 134.01 74.6289 133.856C74.4639 133.676 74.2387 133.217 74.2387 133.217C74.2387 133.217 74.4278 133.951 74.2681 134.078C74.0312 134.265 73.3461 133.79 73.1841 133.309C73.0844 133.582 72.9218 133.835 72.6698 133.768C71.8773 133.558 71.2571 132.437 70.6049 131.881C69.7381 131.142 68.5755 131.092 67.4941 131.108C66.9965 131.116 66.4975 131.128 66.0012 131.079C65.4928 131.028 65.035 130.829 64.539 130.728C63.616 130.542 62.6532 130.456 61.7168 130.402'
        fill='#E27769'
      />
      <path
        d='M70.0869 129.501C70.9574 129.862 71.8797 130.265 72.3697 131.011C72.5163 131.235 72.617 131.479 72.707 131.726C72.8964 132.245 73.041 132.777 73.1853 133.308'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M71.3359 127.927C71.8309 128.242 72.3162 128.578 72.7358 128.987C73.1555 129.397 73.5093 129.885 73.7004 130.439C73.8095 130.756 73.864 131.089 73.9189 131.419C74.0317 132.1 74.1485 132.781 74.2686 133.46'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M73.0352 126.846C73.8594 127.461 74.505 128.313 74.8735 129.272C75.1994 130.121 75.3082 131.035 75.4146 131.938C75.4484 132.225 75.4819 132.511 75.5157 132.797'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M60.7387 100.426C60.7387 100.426 54.1756 101.397 51.6569 102.843C47.7192 105.105 45.9883 108.558 43.479 114.412C40.9696 120.267 39.9519 122.836 39.9275 124.776C39.8913 127.632 41.1768 130.625 46.4294 130.625C55.7863 130.625 63.1805 130.625 63.1805 130.625L66.5603 122.73L53.5257 120.69L57.1227 112.269'
        fill='#735D9D'
      />
      <path
        d='M66.559 122.73L53.5244 120.691L57.1214 112.27'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M48.8955 121.895C48.9959 121.895 50.9798 120.659 53.525 120.691'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M62.9633 122.168L59.3877 130.625'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M70.915 102.437C71.0874 101.547 71.0814 100.596 70.9385 99.6414'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M57.0234 102.212C57.7467 104.018 59.3464 105.515 61.094 106.281C63.2944 107.245 66.279 107.424 68.382 106.136C69.3616 105.536 70.0356 104.747 70.4606 103.846'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M94.043 105.597C97.9616 103.601 101.545 100.948 104.597 97.7817'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M101.353 103.703C103.252 102.232 105.033 100.607 106.673 98.8515'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M38.5053 119.851C37.6764 122.555 37.3772 125.419 37.6302 128.236'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M35.8881 120.254C35.365 121.771 35.0658 123.365 35.0039 124.969'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M62.9351 92.3552L59.3458 94.7608L60.1206 97.3263L59.0413 101.194C58.9723 101.44 59.0142 101.703 59.1567 101.915C59.7431 102.788 61.5627 104.958 65.169 104.955C68.9809 104.951 68.9273 102.423 68.9273 102.423L69.6214 97.0372'
        fill='#E27769'
      />
      <path
        d='M70.1549 92.0346C69.168 90.1956 68.6041 89.0577 67.5673 87.7897C66.6894 86.7161 65.2313 85.199 63.8565 84.8968C62.0864 84.507 60.4208 85.784 58.9131 86.7164C56.4376 88.2472 56.4808 91.5426 57.3168 93.9974C57.959 95.8833 59.287 96.6028 60.9623 97.7527C63.1517 99.2554 67.9106 99.9351 69.9538 98.2885C71.4822 97.0573 71.2001 93.9824 70.1549 92.0346Z'
        fill='#E27769'
      />
      <path
        d='M64.8644 91.8721C64.9816 92.1572 64.8999 92.4607 64.6817 92.5504C64.4638 92.6401 64.1921 92.4818 64.075 92.1967C63.9578 91.9119 64.0395 91.608 64.2577 91.5183C64.4756 91.4286 64.7473 91.5869 64.8644 91.8721Z'
        fill='black'
      />
      <path
        d='M68.3788 89.9363C68.4959 90.2211 68.4142 90.525 68.1964 90.6146C67.9785 90.7043 67.7067 90.5457 67.5896 90.2609C67.4725 89.9758 67.5541 89.6722 67.7723 89.5825C67.9899 89.4928 68.2616 89.6511 68.3788 89.9363Z'
        fill='black'
      />
      <path
        d='M66.4961 91.1748C66.8897 91.5255 67.3639 91.7615 67.8388 91.9807C68.1329 92.1166 69.1139 92.3779 68.895 92.8552C68.7544 93.1617 68.1808 93.646 68.1808 93.646'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M59.3147 100.211C59.3147 100.211 59.7628 99.0646 59.8719 98.6546C60.0557 97.9622 59.473 97.9267 59.2722 97.3169C59.1675 96.9993 59.2535 96.6101 59.3241 96.2956C59.4754 95.6205 59.8231 94.8625 59.5115 94.1811C59.3144 93.7497 58.8907 93.4763 58.5517 93.1447C58.2123 92.813 57.9362 92.3073 58.1394 91.8786C58.3797 91.3713 59.0895 91.3334 59.5249 90.979C59.96 90.625 60.0617 90.0005 60.0319 89.4402C60.0021 88.88 59.8729 88.3158 59.971 87.7636C59.9887 87.6642 60.0162 87.5611 60.0865 87.4885C60.299 87.2683 60.6534 87.4814 60.9201 87.6314C61.3997 87.9011 61.9797 87.8676 62.4813 87.6645C62.7357 87.5614 62.9689 87.3727 63.0606 87.114C63.1175 86.9543 63.1169 86.7806 63.1447 86.6133C63.1724 86.446 63.2384 86.2706 63.3829 86.1819C63.488 86.1177 63.6179 86.1096 63.7407 86.115C64.1279 86.1324 64.5091 86.2679 64.8203 86.4995C65.081 86.6936 65.2273 86.8342 65.5559 86.8218C65.8715 86.8098 66.1751 86.7053 66.4903 86.797C66.8705 86.9078 67.1245 87.2562 67.3487 87.5825C67.9659 88.4808 68.583 89.379 69.2001 90.2772C69.5087 89.8318 69.8219 89.3766 69.9739 88.8566C70.1255 88.3365 70.0903 87.7311 69.749 87.3104C69.42 86.9051 68.8584 86.7234 68.579 86.2823C68.2701 85.795 68.3179 85.0909 68.2845 84.539C68.248 83.9366 68.0626 83.3286 67.7185 82.8199C67.3855 82.3276 66.826 81.945 66.2333 81.9902C65.8903 82.0163 65.564 82.181 65.2203 82.1706C65.0077 82.1642 64.8033 82.0913 64.6081 82.0073C63.7042 81.6194 62.9208 80.9899 62.0202 80.5947C61.1196 80.1994 59.9897 80.0793 59.2126 80.6823C58.8141 80.9916 58.5497 81.4601 58.1159 81.7175C56.8653 82.4598 55.0708 81.0615 53.8791 81.8945C53.11 82.432 53.0862 83.596 52.4387 84.275C51.6107 85.1431 50.1047 84.9149 49.1653 85.6608C48.2175 86.4135 48.2138 87.9142 48.7824 88.9827C49.0635 89.5109 49.4728 90.0547 49.3517 90.6404C49.2761 91.0051 49.0067 91.2926 48.7777 91.5868C48.4508 92.0078 48.1847 92.4937 48.1195 93.0228C48.0542 93.5519 48.2165 94.1279 48.6241 94.4713C48.8775 94.6848 49.2633 94.7859 49.4551 95.0623C49.671 95.3735 49.7315 95.9314 49.774 96.2982C49.8115 96.6205 49.8155 96.9498 49.9129 97.2594C50.179 98.1044 51.1117 98.6078 51.9976 98.6081C52.4062 98.6081 52.8547 98.5315 53.1907 98.7637C53.4691 98.9558 53.5826 99.3035 53.7512 99.5967C54.3001 100.55 55.6354 100.95 56.6183 100.457C56.9878 100.271 57.3291 99.9735 57.7425 99.9672C58.1531 99.9615 58.9258 100.279 59.3147 100.211Z'
        fill='#2C221D'
      />
      <path
        d='M65.0869 99.1554C66.1933 99.4312 68.2897 99.4891 69.8787 98.4851'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M62.0947 91.7863C62.0914 90.6765 62.8243 89.6123 64.0211 89.8221'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M66.2197 89.0215C66.1822 88.7052 66.4198 88.3354 66.7776 88.1537C67.1354 87.972 67.5801 87.9994 67.8301 88.2032'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M61.2549 94.9931C60.622 94.2187 59.0762 94.4339 58.5738 95.2324C57.3667 97.1524 60.291 99.7176 62.0781 98.7825C62.5838 98.5182 63.0815 97.8471 62.8459 97.2247'
        fill='#E27769'
      />
      <path
        d='M59.5039 96.6696L61.9731 96.8459'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M59.7529 94.6038C60.2703 94.5396 60.8105 94.6416 61.2804 94.892'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M59.5576 98.4674C60.2785 98.9413 61.2544 99.2756 62.0449 98.8429C62.5934 98.5427 62.9829 97.8938 62.7868 97.2341'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M66.8812 93.8279C66.7219 94.4222 66.9187 95.2034 67.6007 95.3262C68.1121 95.4185 68.6656 95.1036 68.831 94.6087'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M203.395 59.9814H128.798C127.639 59.9814 126.699 59.0416 126.699 57.8827V21.0071H205.494V57.8823C205.494 59.0416 204.554 59.9814 203.395 59.9814Z'
        fill='#D5D8BC'
      />
      <path
        d='M203.394 15.4107C204.553 15.4107 205.493 16.3504 205.493 17.5094V57.8826C205.493 59.0419 204.553 59.9813 203.394 59.9813H128.797C127.638 59.9813 126.698 59.0415 126.698 57.8826V17.5097C126.698 16.3504 127.638 15.411 128.797 15.411L203.394 15.4107ZM203.394 14.9087H128.797C127.363 14.9087 126.196 16.0753 126.196 17.5094V57.8826C126.196 59.3166 127.363 60.4833 128.797 60.4833H203.394C204.828 60.4833 205.995 59.3166 205.995 57.8826V17.5097C205.995 16.0757 204.828 14.9087 203.394 14.9087Z'
        fill='white'
      />
      <path
        d='M130.426 17.172C131.089 17.172 131.627 17.7099 131.627 18.3732C131.627 19.0365 131.089 19.5743 130.426 19.5743C129.762 19.5743 129.225 19.0365 129.225 18.3732C129.225 17.7099 129.762 17.172 130.426 17.172ZM130.426 16.67C129.487 16.67 128.723 17.4341 128.723 18.3732C128.723 19.3122 129.487 20.0763 130.426 20.0763C131.365 20.0763 132.129 19.3122 132.129 18.3732C132.129 17.4341 131.365 16.67 130.426 16.67Z'
        fill='white'
      />
      <path
        d='M135.081 17.1719C135.744 17.1719 136.282 17.7097 136.282 18.373C136.282 19.0363 135.744 19.5741 135.081 19.5741C134.418 19.5741 133.88 19.0363 133.88 18.373C133.88 17.7097 134.418 17.1719 135.081 17.1719ZM135.081 16.6699C134.142 16.6699 133.378 17.4339 133.378 18.373C133.378 19.3121 134.142 20.0761 135.081 20.0761C136.02 20.0761 136.784 19.3121 136.784 18.373C136.784 17.4339 136.02 16.6699 135.081 16.6699Z'
        fill='white'
      />
      <path
        d='M126.699 21.0071H205.494'
        stroke='white'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M194.735 53.013C193.26 50.5486 191.695 47.9914 189.272 46.488C186.849 44.9847 183.301 44.9278 181.493 47.151C179.889 49.1215 180.187 51.9946 180.571 54.521C178.787 52.2433 176.697 50.2129 174.378 48.5037C172.588 47.1848 170.614 46.0382 168.44 45.6249C166.183 45.1956 163.608 45.6688 161.756 47.0647C159.229 48.9696 159.268 51.9689 159.516 54.8621C156.448 49.0476 153.039 43.2793 148.316 38.6317C147.094 37.4289 145.658 36.3875 144.006 35.9266C143.058 35.6626 141.989 35.611 141.14 36.107C139.849 36.8603 139.507 38.5608 139.47 40.0554C139.426 41.8586 139.633 43.6678 140.086 45.4141C139.262 44.5286 138.174 43.873 136.986 43.6457C134.253 43.1223 131.555 45.1899 131.399 47.996C131.237 50.9153 133.013 53.7021 134.37 56.1542C134.887 57.0886 135.419 58.0197 136.004 58.9135C136.118 59.0879 136.554 59.9547 136.818 59.9547C136.819 59.9547 198.644 59.9547 198.644 59.9547C197.341 57.7767 196.038 55.19 194.735 53.013Z'
        fill='#B5AE6B'
      />
      <mask
        id='mask0_992_2094'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='126'
        y='15'
        width='80'
        height='45'
      >
        <path
          d='M203.395 59.98H128.798C127.639 59.98 126.699 59.0402 126.699 57.8813V17.5081C126.699 16.3488 127.639 15.4094 128.798 15.4094H203.395C204.554 15.4094 205.493 16.3492 205.493 17.5081V57.8813C205.494 59.0402 204.554 59.98 203.395 59.98Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_992_2094)'>
        <path
          d='M200.144 57.217L179.466 17.5858L173.589 17.2401L168.975 21.0064L157.104 29.6378L170.449 68.7479L200.144 57.217Z'
          fill='white'
        />
        <path
          d='M161.294 29.067C162.448 30.0285 164.055 30.42 165.522 30.0971'
          stroke='black'
          strokeWidth='0.334667'
          stroke-miterlimit='10'
        />
        <path
          d='M166.968 29.6376C168.413 29.1516 169.695 28.1935 170.57 26.9452C171.446 25.6969 171.91 24.1651 171.875 22.6407'
          stroke='black'
          strokeWidth='0.334667'
          stroke-miterlimit='10'
        />
        <path
          d='M194.502 42.4817C190.924 35.6585 180.188 14.1555 177.355 15.2144C174.105 16.4292 170.449 19.5617 170.449 19.5617C170.449 19.5617 172.201 25.1671 172.334 25.6985C172.821 27.6366 173.322 29.5706 173.837 31.5013C175.121 36.3074 176.264 41.1845 177.848 45.9027C179.458 50.6948 181.241 55.431 183.164 60.1059C183.934 61.9801 184.553 64.1765 186.02 65.6433C186.852 66.4904 188.015 67.081 189.198 66.977C190.015 66.905 190.765 66.5171 191.491 66.1369C194.686 64.4636 203.592 60.4734 203.592 60.4734C203.592 60.4734 199.014 51.0877 194.502 42.4817Z'
          fill='#4C4139'
        />
        <path
          d='M176.26 68.7072C175.39 65.5399 173.902 62.6253 172.799 59.5467C171.357 55.519 170.076 51.4354 168.588 47.4238C166.318 41.3044 163.1 32.8423 160.636 26.7986C160.636 26.7986 156.119 29.3899 155.208 30.0181C154.297 30.6466 154.495 32.1415 154.495 32.1415C158.09 45.55 168.979 76.0023 168.979 76.0023C170.269 75.3209 173.466 73.5247 174.755 72.8434C176.454 71.9458 176.748 70.4866 176.26 68.7072Z'
          fill='#4C4139'
        />
        <path
          d='M156.104 29.4547C160.279 35.8699 163.531 41.0937 167.883 47.3908'
          stroke='black'
          strokeWidth='0.334667'
          stroke-miterlimit='10'
        />
        <path
          d='M176.118 16.8342C176.985 25.3444 177.513 33.8888 177.702 42.4408'
          stroke='black'
          strokeWidth='0.334667'
          stroke-miterlimit='10'
        />
      </g>
      <path
        d='M132.77 62.2627C131.898 62.927 131.003 63.5586 130.085 64.1559C129.199 64.7322 128.251 65.2215 127.381 65.8172C127.166 65.9641 126.966 66.1305 126.766 66.2961C126.036 66.9005 125.301 67.5113 124.722 68.2606C124.645 68.3604 124.569 68.4644 124.465 68.5357C124.361 68.6073 124.221 68.6408 124.107 68.5866C123.989 68.53 123.929 68.3972 123.895 68.2707C123.754 67.7452 123.897 67.1837 124.112 66.6837C124.25 66.3617 124.418 66.0542 124.563 65.7356C124.684 65.4719 124.844 65.1927 124.847 64.9002C122.503 65.4759 120.454 66.8617 118.247 67.8369C117.795 68.0367 116.875 67.9939 116.779 67.6067C116.652 67.095 119.917 65.3832 121.481 64.159C120.39 64.5177 119.234 64.8909 118.216 65.428C117.51 65.8002 116.757 66.094 115.965 66.2162C115.521 66.2844 114.518 66.3326 114.837 65.5903C114.931 65.3715 115.131 65.2188 115.325 65.0813C116.834 64.0137 118.556 63.3621 120.121 62.3775C118.475 62.747 116.882 63.6205 115.207 63.418C115.044 63.3983 114.87 63.3621 114.758 63.2423C114.587 63.0599 114.554 62.8387 114.714 62.6463C114.874 62.4542 115.114 62.3514 115.345 62.2554C117.038 61.5512 118.811 60.7581 120.504 60.0539C119.638 60.1497 118.806 60.4368 117.958 60.6406C117.111 60.8444 116.212 60.9639 115.375 60.7239C115.105 60.6466 114.791 60.4164 114.896 60.1563C114.946 60.0305 115.079 59.9616 115.201 59.903C117.28 58.9124 119.359 57.9218 121.437 56.9308C122.02 56.6531 122.603 56.3749 123.196 56.1193C124.485 55.5644 125.73 54.9299 127.022 54.3763C128.378 53.7953 129.742 53.2321 131.112 52.6859'
        fill='#D16159'
      />
      <path
        d='M124.807 64.8872C125.438 64.7192 126.076 64.5737 126.719 64.4505'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M121.394 64.1422C122.281 63.7185 123.192 63.3413 124.119 63.013'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M120.121 62.3457C120.845 62.0311 121.569 61.7162 122.293 61.4016'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M119.689 60.3467C120.222 60.153 120.742 59.9234 121.244 59.6597'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M155.208 30.0173C153.66 31.048 152.13 32.1993 151.148 33.2672C149.573 34.98 140.315 46.2014 140.315 46.2014C140.315 46.2014 130.831 51.9209 125.396 55.0795L131.339 64.7617C131.339 64.7617 142.357 60.8002 147.976 56.8529C153.084 53.2646 162.863 41.5074 162.863 41.5074'
        fill='#4C4139'
      />
      <path
        d='M159.082 46.2038L156.104 36.9409'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M130.396 52.1361L136.99 62.3799'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M129.588 61.9098L135.058 59.3771'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M133.251 59.25C133.279 59.501 133.098 59.7266 132.847 59.7544C132.596 59.7818 132.37 59.6007 132.343 59.3497C132.315 59.0987 132.496 58.8732 132.747 58.8454C132.998 58.818 133.223 58.999 133.251 59.25Z'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M130.578 60.4601C130.831 60.4601 131.035 60.2555 131.035 60.003C131.035 59.7505 130.831 59.5458 130.578 59.5458C130.326 59.5458 130.121 59.7505 130.121 60.003C130.121 60.2555 130.326 60.4601 130.578 60.4601Z'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M140.251 46.3416C140.243 46.28 140.235 46.2185 140.228 46.1572C141.49 45.7787 142.696 45.2091 143.79 44.4742'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M144.712 35.4255C146.504 33.2696 148.698 31.4487 151.148 30.0846'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M146.155 30.5C147.851 29.2377 149.706 28.1881 151.662 27.3843'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M164.294 12.8782L165.618 16.8002L170.343 21.3711C170.343 21.3711 170.466 24.0906 167.793 26.9416C165.14 29.7709 162.266 27.872 162.266 27.872L158.836 22.8282'
        fill='#D16159'
      />
      <path
        d='M153.233 23.1003C152.689 21.359 152.004 17.6027 152.057 16.1724C152.101 14.9612 152.463 13.7762 153.261 12.8398C154.288 11.634 156.703 12.066 158.245 11.9194C160.777 11.6788 162.359 14.6791 163.073 16.83C163.621 18.4823 163.882 20.1834 163.322 21.8687C162.412 24.609 159.489 27.3787 156.397 26.6294C154.716 26.2221 153.759 24.788 153.233 23.1003Z'
        fill='#D16159'
      />
      <path
        d='M166.685 12.3878C166.279 11.9541 165.72 11.6137 165.539 11.0475C165.439 10.7335 165.284 9.79414 165.182 9.48089C164.617 7.73326 163.152 7.14826 161.486 7.43541C161.309 5.76408 159.536 5.60277 158.08 5.58604C157.474 5.57901 156.857 5.51978 156.314 5.22962C155.739 4.92273 155.219 4.48833 154.548 4.42441C153.95 4.36752 153.333 4.56464 152.836 4.89161C151.11 6.02646 150.617 8.22221 148.503 8.88518C147.835 9.09469 147.137 9.1566 146.56 9.59501C146.13 9.92198 145.809 10.4113 145.749 10.9487C145.663 11.7155 146.169 12.182 146.692 12.6485C147.302 13.1927 147.658 13.8861 147.609 14.7141C147.579 15.2154 147.445 15.7037 147.365 16.1993C147.136 17.6106 147.587 18.9446 148.769 19.799C149.019 19.979 149.356 20.1477 150.269 20.3458C150.912 20.4854 152.58 20.2444 152.58 20.2444C152.58 20.2444 152.169 17.8439 152.176 16.9095C152.184 16.0206 152.455 15.1923 152.975 14.4821C153.418 13.8761 154.389 13.6629 155.112 13.6953C156.194 13.7439 157.228 14.3406 158.305 14.2144C158.752 14.1619 159.177 13.9735 159.528 13.6927C160.976 14.6301 162.474 16.0082 162.806 17.6886C162.823 17.7739 163.035 18.7689 162.96 18.7846C164.202 18.5236 165.766 18.4232 166.324 17.0678C166.516 16.6003 166.419 16.1086 166.565 15.6347C166.685 15.2422 167.036 14.9557 167.2 14.5789C167.516 13.8496 167.228 12.9674 166.685 12.3878Z'
        fill='#2C221D'
      />
      <path
        d='M161.525 17.4828C161.59 16.4028 163.081 15.6123 164.027 15.9942C166.302 16.9125 165.363 21.0135 163.204 21.3261C162.594 21.4144 161.733 21.1417 161.545 20.4466'
        fill='#D16159'
      />
      <path
        d='M164.123 17.8425L162.07 19.5614'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M162.595 16.19C162.101 16.4618 161.692 16.8931 161.438 17.4102'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M165.214 19.4529C164.882 20.3247 164.238 21.2363 163.271 21.3578C162.6 21.4421 161.848 21.1202 161.602 20.4177'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M160.763 25.6615C160.763 25.6615 161.867 24.9597 162.594 23.4142'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M155.076 18.9459C155.179 19.909 155.285 20.8719 155.394 21.8344C155.409 21.9672 155.429 22.1098 155.521 22.2072C155.884 22.5911 156.717 22.4066 157.104 22.1767'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M158.011 22.5714L156.346 23.544C156.346 23.544 156.99 24.7789 157.635 24.5376C158.836 24.0888 158.011 22.5714 158.011 22.5714Z'
        fill='white'
      />
      <path
        d='M155.924 16.8634C156.095 16.513 156.445 16.2777 156.816 16.1579C157.443 15.9555 158.16 16.0549 158.708 16.4203'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M152.034 18.2616C152.094 17.8944 152.305 17.6167 152.551 17.4497C152.967 17.1675 153.503 17.1706 153.965 17.457'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M158.127 18.2995C158.213 18.659 158.056 19.004 157.777 19.0699C157.498 19.1359 157.203 18.8983 157.118 18.5388C157.033 18.1794 157.19 17.8344 157.468 17.7684C157.747 17.7025 158.042 17.9401 158.127 18.2995Z'
        fill='black'
      />
      <path
        d='M154.287 19.4428C154.373 19.8022 154.216 20.1473 153.937 20.2132C153.658 20.2795 153.363 20.0415 153.278 19.6821C153.193 19.3226 153.35 18.9776 153.629 18.9117C153.907 18.8458 154.202 19.0834 154.287 19.4428Z'
        fill='black'
      />
      <path
        d='M153.276 14.1611C152.56 14.5459 152.248 15.3873 151.764 16.0406C150.982 17.0964 149.626 17.6978 148.317 17.5683'
        stroke='#635149'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M159.65 13.5962C160.299 12.9975 160.764 12.2033 160.97 11.3452'
        stroke='#635149'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M220.436 102.178H164.348C163.188 102.178 162.249 101.238 162.249 100.079V60.2312H222.535V100.079C222.534 101.238 221.595 102.178 220.436 102.178Z'
        fill='#F9D4BB'
      />
      <path
        d='M220.437 54.6354C221.596 54.6354 222.535 55.5752 222.535 56.7341V100.079C222.535 101.239 221.595 102.178 220.437 102.178H164.349C163.189 102.178 162.25 101.238 162.25 100.079V56.7341C162.25 55.5748 163.19 54.6354 164.349 54.6354H220.437ZM220.437 54.1334H164.349C162.915 54.1334 161.748 55.3001 161.748 56.7341V100.079C161.748 101.514 162.915 102.68 164.349 102.68H220.437C221.871 102.68 223.037 101.514 223.037 100.079V56.7341C223.037 55.3001 221.871 54.1334 220.437 54.1334Z'
        fill='white'
      />
      <path
        d='M167.178 57.5969C167.178 58.2602 166.64 58.798 165.977 58.798C165.313 58.798 164.775 58.2602 164.775 57.5969C164.775 56.9336 165.313 56.3958 165.977 56.3958C166.64 56.3958 167.178 56.9336 167.178 57.5969Z'
        stroke='white'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M171.834 57.5969C171.834 58.2602 171.296 58.798 170.633 58.798C169.969 58.798 169.432 58.2602 169.432 57.5969C169.432 56.9336 169.969 56.3958 170.633 56.3958C171.296 56.3958 171.834 56.9336 171.834 57.5969Z'
        stroke='white'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M162.249 60.2312H222.534'
        stroke='white'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M206.996 86.0282C205.616 85.7866 205.225 89.4984 205.887 90.7336C204.069 88.134 201.768 84.1521 199.95 81.5524C197.911 78.6365 195.474 75.0047 191.797 74.0555C188.484 73.2005 186.757 76.0853 186.705 79.0307C186.655 81.8506 186.939 84.6953 187.461 87.4643C188.03 90.4833 188.77 93.922 190.413 96.5579C188.666 93.7567 185.87 92.8096 182.746 93.0696C181.291 93.1908 179.778 93.6804 178.86 94.8152C177.39 96.6305 177.941 99.9293 178.568 102.18C179.934 102.18 181.3 102.18 182.666 102.18C189.933 102.18 218.719 102.192 218.719 102.192C218.719 102.192 211.476 86.8127 206.996 86.0282Z'
        fill='#EF9748'
      />
      <path
        d='M165.245 80.8C159.256 80.889 153.319 79.6223 147.589 77.8757C141.859 76.1294 131.42 72.2951 131.42 72.2951L128.439 81.295C128.439 81.295 143.871 91.0709 164.407 92.7406'
        fill='#E27769'
      />
      <path
        d='M178.075 83.2439C174.083 79.8571 165.435 80.0991 162.955 80.1958C160.475 80.2925 156.057 79.5602 156.057 79.5602L154.43 93.1189C154.43 93.1189 163.612 94.6601 168.721 95.0332'
        fill='#2C221D'
      />
      <path
        d='M166.825 86.4964C167.452 88.2641 167.166 90.8648 167.173 92.7403C167.179 94.4133 167.767 95.3427 168.014 96.9973C168.31 98.9748 169.432 100.387 170.615 102.179H196.046L194.706 88.0791L191.244 83.0761L183.935 81.1274L167.434 85.4673'
        fill='#2C221D'
      />
      <path
        d='M174.809 83.0763C174.556 83.9715 174.371 84.9759 174.525 85.9036C174.705 86.9906 175.395 87.6749 176.378 88.0792'
        stroke='#6D574E'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M177.629 88.3787C182.136 89.1863 186.878 85.9648 187.331 81.8638'
        stroke='#6D574E'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M211.535 100.554C211.168 99.4913 210.481 98.573 209.774 97.6998C207.829 95.2989 205.653 93.0861 203.284 91.1019L194.774 98.8484L200.04 103.953L193.89 115.101L202.048 117.43C202.048 117.43 208.291 110.535 210.681 106.691C211.853 104.804 212.264 102.671 211.535 100.554Z'
        fill='#E27769'
      />
      <path
        d='M195.518 112.604C195.518 112.604 191.95 117.739 191.589 118.665C191.265 119.498 191.089 120.54 190.961 121.427C190.611 123.872 191.922 126.386 192.91 127.574C193.021 127.708 193.186 127.794 193.352 127.825C193.718 127.893 193.865 127.703 193.857 127.271C194.057 127.543 194.257 127.814 194.457 128.087C194.54 128.199 194.627 128.315 194.745 128.374C194.972 128.486 195.257 128.349 195.431 128.127C195.605 127.905 195.694 127.615 195.779 127.335C195.991 127.642 196.32 127.963 196.637 127.776C196.954 127.588 197.228 126.909 197.157 126.519C197.262 126.862 197.716 126.871 197.964 126.622C198.212 126.373 198.303 125.982 198.377 125.618C198.564 124.696 198.74 123.745 199.192 122.94C199.493 122.403 199.902 121.957 200.259 121.466C201.421 119.866 201.996 117.827 202.371 115.818'
        fill='#E27769'
      />
      <path
        d='M197.859 120.519C197.698 120.875 197.537 121.23 197.377 121.586C197.246 121.875 197.115 122.164 197.01 122.464C196.542 123.8 196.619 125.328 197.22 126.598'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M195.173 120.385C194.846 122.002 194.713 123.945 194.946 125.161C195.096 125.948 195.44 126.697 195.861 127.372'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M192.821 119.778C192.821 119.778 192.612 120.97 192.562 121.644C192.405 123.787 192.689 125.856 193.856 127.444'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M130.691 81.4464C130.049 81.3842 129.407 81.3219 128.765 81.2597C128.19 81.2041 127.611 81.1472 127.061 80.9709C126.695 80.8531 126.347 80.6841 126.001 80.5154C124.575 79.8213 123.845 79.6135 122.481 78.8099C121.698 78.3484 120.896 77.9134 120.061 77.5523C119.243 77.1985 118.394 77.0081 117.638 76.5299C117.573 76.4884 117.505 76.4415 117.474 76.3702C117.451 76.3153 117.453 76.2531 117.462 76.1938C117.637 74.9609 120.15 75.243 121.127 75.5161C121.422 75.5985 121.727 75.6972 122.027 75.6363C122.047 75.2441 121.875 74.8686 121.684 74.5255C121.121 73.5162 120.297 72.712 119.554 71.8345C118.867 71.0226 118.17 70.2113 117.537 69.3559C116.943 68.5551 116.333 66.8108 116.798 66.5979C117.264 66.3851 117.015 66.8101 117.166 66.8295C116.865 66.6445 116.979 65.9045 117.195 65.613C117.411 65.3219 118.01 65.7629 118.217 66.0454C118.001 65.775 118.074 65.1612 118.295 65.0515C118.617 64.8915 118.998 65.107 119.297 65.2877C119.595 65.4684 119.883 65.688 120.231 65.7512C120.143 65.5314 120.091 65.2968 120.075 65.0585C120.245 64.8517 120.573 64.9584 120.802 65.0829C125.458 67.6193 129.431 71.461 134.381 73.7217'
        fill='#E27769'
      />
      <path
        d='M121.047 73.5822C121.57 74.3319 121.922 75.2338 122.195 76.3399'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M117.181 66.5693C117.799 67.338 118.624 67.8705 119.345 68.5294C120.492 69.5779 121.583 70.685 122.691 71.7733'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M118.214 65.9716C118.568 66.3062 118.944 66.6168 119.339 66.9013C119.763 67.2058 120.207 67.4799 120.645 67.7644C121.895 68.5773 123.088 69.4789 124.211 70.4604'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M120.395 65.849C120.788 66.2248 121.286 66.4675 121.766 66.7231C123.27 67.5233 124.679 68.5039 125.951 69.6374'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M130.878 81.7397C130.878 81.7397 128.247 81.3829 127.173 81.0995'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M189.104 82.5177C190.916 82.6927 192.729 82.8621 194.453 83.513C196.632 84.3356 198.526 85.8818 200.309 87.4624C202.173 89.1136 204.073 91.3613 205.887 93.0845L196.593 101.217L190.012 94.8043'
        fill='#2C221D'
      />
      <path
        d='M200.04 103.953C200.04 103.953 201.415 102.193 202.808 101.217'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M193.888 98.5818L203.579 90.7342'
        stroke='#6D574E'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M157.982 93.6841L159.39 80.0063'
        stroke='#6D574E'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M166.825 91.1019C166.825 91.1019 167.468 94.0212 167.644 95.2731'
        stroke='#6D574E'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M189.684 94.7796C191.698 96.3345 196.593 101.217 196.593 101.217'
        stroke='#6D574E'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M179.344 72.8135L183.675 74.5689L183.421 77.4564L185.604 81.6762C185.604 81.6762 184.539 85.6557 179.758 86.6466C175.721 87.4833 175.812 84.8783 175.812 84.8783L173.89 79.3292'
        fill='#E27769'
      />
      <path
        d='M170.195 75.0369C170.834 72.872 171.18 71.543 171.998 69.9717C172.691 68.6414 173.901 66.7138 175.289 66.0906C177.078 65.2878 179.123 66.2727 180.925 66.9269C183.884 68.0019 184.564 71.5008 184.221 74.2843C183.957 76.4228 182.709 77.4776 181.189 79.0646C179.202 81.1386 174.313 82.9076 171.787 81.6148C169.897 80.6473 169.517 77.3297 170.195 75.0369Z'
        fill='#E27769'
      />
      <path
        d='M201.132 88.122C202.296 87.7395 202.869 86.3697 202.804 85.3965C202.699 83.8292 201.967 83.021 201.847 82.0528C201.768 81.4223 201.956 80.7841 201.902 80.1512C201.814 79.1061 201.056 78.1961 200.119 77.7245C199.183 77.253 198.093 77.168 197.048 77.2614C196.247 77.333 195.443 77.5037 194.646 77.3902C193.981 77.2955 193.359 77.0064 192.779 76.6663C191.754 76.0653 190.819 75.2828 190.159 74.2949C189.037 72.6149 188.798 70.5018 187.933 68.6762C187.497 67.7565 186.891 66.9202 186.167 66.2063C184.406 64.4721 182.73 63.8299 180.234 63.7469C178.525 63.69 176.146 63.9182 174.838 65.5126C174.838 65.5126 172.31 65.5775 171.104 66.8509C169.672 68.3626 169.775 70.5506 171.025 72.2946C171.672 71.234 172.222 70.1122 173.168 69.297C173.059 69.469 173.111 69.7103 173.251 69.8582C173.391 70.0061 173.599 70.0731 173.802 70.0895C174.343 70.1333 174.854 69.8639 175.329 69.6025C175.169 70.0312 175.101 70.4947 175.131 70.9516C175.137 71.0479 175.151 71.1507 175.214 71.2233C175.287 71.3063 175.405 71.3287 175.515 71.3381C176.26 71.4007 177.027 71.0423 177.457 70.4305C177.253 70.985 177.075 71.6808 177.486 72.1055C177.776 72.4057 178.267 72.4278 178.654 72.2705C179.04 72.1132 179.347 71.812 179.643 71.5178C179.501 71.6594 179.688 72.4582 179.723 72.6426C179.799 73.0466 179.923 73.4388 180.061 73.8253C180.483 75.0137 181.003 76.1717 181.68 77.2383C182.378 78.3393 183.376 79.1743 184.089 80.2473C184.541 80.9273 184.923 81.6719 185.531 82.2175C186.278 82.8878 187.308 83.3921 188.289 83.5919C189.278 83.7934 190.301 83.702 191.301 83.6692C194.999 83.5487 197.802 85.4001 201.132 88.122Z'
        fill='#893D33'
      />
      <path
        d='M192.505 64.1776C192.293 63.6518 191.981 63.1699 191.582 62.8021C190.14 61.4752 186.998 61.5612 185.924 63.364C185.334 64.355 185.621 65.6297 186.069 66.6926L186.951 68.6297C188.182 69.2987 189.74 69.3271 190.994 68.704C192.043 68.1836 192.782 67.2231 192.834 66.0327C192.862 65.4256 192.747 64.7733 192.505 64.1776Z'
        fill='#893D33'
      />
      <path
        d='M179.68 75.4155C179.98 74.521 181.415 74.195 182.125 74.7315C183.831 76.0223 182.107 79.2612 180.219 79.0329C179.684 78.9683 179.021 78.543 179.021 77.9151'
        fill='#E27769'
      />
      <path
        d='M181.783 76.3099L179.664 77.2898'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M180.874 74.571C180.396 74.6871 179.954 74.9575 179.623 75.335'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M182.336 77.9139C181.858 78.5725 181.109 79.1933 180.267 79.0755C179.683 78.9938 179.122 78.5514 179.075 77.9042'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M174.873 82.1697C174.873 82.1697 176.862 82.075 178.877 80.7145'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M172.784 73.9467C172.47 74.4949 172.143 75.0588 171.637 75.4367C171.515 75.527 171.384 75.607 171.285 75.7215C171.144 75.8854 171.084 76.116 171.127 76.3282C171.17 76.5404 171.315 76.7295 171.508 76.8262'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M171.891 78.106C172.209 78.3701 172.684 78.4738 173.061 78.272C173.537 78.017 173.546 77.4096 173.562 76.9363'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M175.104 72.7719C175.452 72.6989 175.816 72.6832 176.162 72.7649C176.508 72.8465 176.835 73.0303 177.056 73.3087C177.336 73.6621 177.424 74.127 177.502 74.5711'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M171.232 71.4504C171.563 71.2132 172.027 71.1978 172.393 71.3751C172.759 71.5529 173.026 71.9049 173.141 72.2951'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M175.687 74.7715C175.551 75.0553 175.275 75.2059 175.071 75.1079C174.866 75.0098 174.811 74.7003 174.946 74.4165C175.083 74.1327 175.358 73.9821 175.563 74.0801C175.768 74.1782 175.823 74.4877 175.687 74.7715Z'
        fill='black'
      />
      <path
        d='M171.929 73.5349C171.793 73.8187 171.517 73.9693 171.312 73.8713C171.107 73.7732 171.052 73.4636 171.188 73.1798C171.324 72.896 171.6 72.7454 171.804 72.8435C172.009 72.9415 172.065 73.2511 171.929 73.5349Z'
        fill='black'
      />
      <path
        d='M210.921 112.348C212.96 110.275 214.405 107.623 215.043 104.786'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M215.591 111.193C216.208 109.977 216.601 108.647 216.746 107.291'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M175.671 46.1884C175.671 46.1884 172.188 47.7861 169.849 48.8463C168.526 49.446 166.309 51.0865 165.552 52.3348C164.589 53.9228 164.337 55.8867 164.447 57.5081C164.52 58.5811 165.01 59.7962 165.729 60.9659C166.203 61.7363 166.708 62.5418 167.149 62.4371C167.59 62.3327 167.431 61.2527 167.431 61.2514C167.432 61.3166 167.953 62.341 168.074 62.4227C168.234 62.5321 168.425 62.6268 168.591 62.5398C168.817 62.4214 168.97 62.2922 169.079 62.0619C169.171 61.8672 169.179 61.665 169.198 61.4478C169.215 61.2507 169.199 60.7751 169.189 60.5747C169.286 60.7909 169.379 61.4652 169.564 61.4297C169.749 61.3939 170.05 61.2397 170.216 61.0375C170.538 60.6449 170.708 60.1537 170.873 59.6734C170.874 59.7895 170.876 59.909 170.92 60.0168C170.964 60.1245 171.059 60.2196 171.175 60.2283C171.321 60.239 171.917 59.8039 172.004 59.6861C172.379 59.1764 172.519 58.4944 172.791 57.9224C173.017 57.4452 173.239 57.1072 173.565 56.6922C173.863 56.3137 174.318 55.8455 174.752 55.6176C175.637 55.1534 176.18 55.0269 177.085 54.5992C177.847 54.2388 178.594 53.7933 179.122 53.1196'
        fill='#D16159'
      />
      <path
        d='M170.794 59.8744C170.861 59.1124 170.954 58.3527 171.073 57.597C171.152 57.0934 171.244 56.586 171.446 56.1175C171.775 55.3497 172.374 54.7353 172.96 54.1396'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M169.269 60.7422C168.973 59.4722 169.005 58.1519 169.039 56.848C169.048 56.4876 169.058 56.1242 169.144 55.7741C169.293 55.17 169.659 54.6459 170.017 54.1376'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M167.468 61.5046C167.06 60.2409 166.65 58.9635 166.537 57.6402C166.516 57.3869 166.505 57.1322 166.514 56.8778C166.548 55.9287 166.857 55.0017 167.324 54.1747'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M178.635 27.3022L184.765 38.8663L171.085 48.2343L180.088 55.3252C180.088 55.3252 195.438 50.3283 199.619 47.8494C202.902 45.9034 204.31 40.8489 197.986 32.6047C191.662 24.3605 187.297 19.4714 186 18.0966C183.209 15.1378 179.888 13.9089 176.794 15.4668'
        fill='#4C4139'
      />
      <path
        d='M178.635 27.3025L184.764 38.8666L171.085 48.2342'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M178.989 52.1368C178.989 52.3891 178.784 52.5939 178.531 52.5939C178.279 52.5939 178.074 52.3895 178.074 52.1368C178.074 51.8844 178.279 51.6796 178.531 51.6796C178.784 51.6796 178.989 51.8844 178.989 52.1368Z'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M181.354 51.1704C181.606 51.1704 181.811 50.9657 181.811 50.7133C181.811 50.4608 181.606 50.2561 181.354 50.2561C181.101 50.2561 180.896 50.4608 180.896 50.7133C180.896 50.9657 181.101 51.1704 181.354 51.1704Z'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M175.914 52.0376C175.964 52.0771 181.811 49.13 181.811 49.13'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M176.233 44.708C176.291 44.6681 186.745 53.0622 186.745 53.0622'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M184.43 38.9815C185.713 38.4802 187.003 37.94 188.375 37.7339C189.841 37.5133 191.331 37.5893 192.805 37.6656'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M180.087 55.3245L197.805 48.8849'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M183.186 12.5793C179.645 9.25276 176.029 5.94324 171.843 3.47742C164.093 -1.08777 153.276 -0.381287 147.93 2.94028C143.826 5.48977 141.663 8.66509 139.027 12.5971C135.728 17.519 132.268 22.8138 126.832 25.1702C124.182 26.3188 121.268 26.6638 118.433 27.2187C115.599 27.7736 112.701 28.6049 110.53 30.5095C108.358 32.4137 107.121 35.6469 108.294 38.2864C109.215 40.3597 111.484 41.6639 113.752 41.7281C116.02 41.7927 118.231 40.7399 119.864 39.1646C124.03 35.1449 125.969 24.5701 118.274 21.526'
        stroke='#ED725A'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M15.0586 84.2689C15.5482 86.5912 16.7861 89.063 18.4595 90.97C20.6378 93.4525 25.0805 95.0592 26.9908 91.4495C27.8793 89.7708 28.3224 87.0544 26.205 85.8529C26.0547 85.7676 25.8861 85.6909 25.704 85.6889C25.2947 85.6846 25.0233 86.0403 24.9025 86.3653C24.3366 87.888 25.2475 89.5336 26.4771 90.7568C27.0477 91.3244 27.7123 91.8535 28.5353 92.1359C29.3579 92.4184 30.3656 92.4154 31.0834 91.9776C32.1999 91.2966 32.4937 89.7966 32.4121 88.7227'
        stroke='#8F96DB'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M10.3789 23.1237C12.3491 20.6395 15.002 18.3955 17.9832 17.2456C19.5963 16.6235 21.7037 16.4002 23.3998 16.7369C24.2465 16.9049 25.2301 17.172 25.7475 17.9333C26.2933 18.7365 25.6561 20.2251 26.7354 20.6803C27.0125 20.7971 27.3278 20.769 27.6253 20.7241C28.5607 20.5836 29.471 20.3018 30.4067 20.1642C31.3428 20.027 32.3391 20.0454 33.1818 20.4755C34.0244 20.9055 34.665 21.8269 34.5392 22.7646C34.49 23.1317 34.3303 23.4952 34.3983 23.8593C34.5121 24.4684 35.2021 24.787 35.8193 24.8452C37.097 24.9654 38.3119 24.9239 39.3982 25.7418C40.1954 26.3418 40.6532 27.4151 40.2452 28.2765'
        stroke='#FFDD99'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M93.8535 20.7613C94.3502 19.6562 94.9067 18.5481 95.7735 17.7017C96.6403 16.8554 97.8776 16.3032 99.0666 16.5344C99.6814 16.6542 100.262 16.9742 100.889 16.9611C101.75 16.943 102.487 16.2804 102.875 15.5107C103.262 14.7409 103.375 13.8678 103.532 13.0207C103.783 11.668 104.19 10.2855 105.116 9.26746C106.041 8.24941 107.605 7.70357 108.841 8.3073'
        stroke='#FFDD99'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M35.5393 133.466C35.8832 131.414 34.4984 129.471 32.4461 129.127C30.3938 128.783 28.4512 130.168 28.1072 132.22C27.7632 134.273 29.1481 136.215 31.2004 136.559C33.2527 136.903 35.1953 135.518 35.5393 133.466Z'
        stroke='#909DF4'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M95.9553 7.47069C97.643 7.47069 99.0111 6.10254 99.0111 4.41485C99.0111 2.72716 97.643 1.35901 95.9553 1.35901C94.2676 1.35901 92.8994 2.72716 92.8994 4.41485C92.8994 6.10254 94.2676 7.47069 95.9553 7.47069Z'
        stroke='#8F96DB'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path d='M204.693 121.645L206.719 134.988L214.68 129.123L204.693 121.645Z' fill='#FFDD99' />
      <path
        d='M4.27092 107.006L9.65671 100.9L0.456055 101.23L4.27092 107.006Z'
        stroke='#8F96DB'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M12.8776 122.127C14.0818 122.127 15.058 121.151 15.058 119.947C15.058 118.743 14.0818 117.767 12.8776 117.767C11.6734 117.767 10.6973 118.743 10.6973 119.947C10.6973 121.151 11.6734 122.127 12.8776 122.127Z'
        fill='#FFDD99'
      />
      <path d='M17.5378 28.9427L12.2959 40.3803L28.313 38.0574L17.5378 28.9427Z' fill='#ED725A' />
      <path
        d='M7.25885 57.4398C7.25885 58.1708 6.66649 58.7631 5.93558 58.7631C5.20466 58.7631 4.6123 58.1708 4.6123 57.4398C4.6123 56.7089 5.20466 56.1166 5.93558 56.1166C6.66649 56.1166 7.25885 56.7089 7.25885 57.4398Z'
        fill='#909DF4'
      />
      <path
        d='M186.858 5.27212C186.858 6.00304 186.266 6.5954 185.535 6.5954C184.804 6.5954 184.212 6.00304 184.212 5.27212C184.212 4.54121 184.804 3.94885 185.535 3.94885C186.266 3.94885 186.858 4.54121 186.858 5.27212Z'
        fill='#ED725A'
      />
      <path
        d='M211.193 120.816C212.18 120.411 213.456 120.489 214.349 121.089C215.138 121.618 215.55 122.614 216.5 122.924C217.895 123.379 219.125 122.081 220.469 121.992C221.632 121.915 222.57 122.703 223.024 123.718C223.414 124.587 223.488 125.559 223.557 126.508'
        stroke='#8F96DB'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M200.952 30.0685C201.436 28.866 202.71 28.0287 204.006 28.0618C204.665 28.0785 205.334 28.2974 205.972 28.1321C207.959 27.6177 207.793 24.1582 209.756 23.5592C211.117 23.1442 212.596 24.4618 213.927 23.9621C215.073 23.5321 215.354 22.0897 215.716 20.9213C216.697 17.7628 219.6 15.2886 222.874 14.8204'
        stroke='#8F96DB'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M185.811 99.5164C186.97 99.5164 187.909 100.456 187.909 101.615V138.777C187.909 139.936 186.97 140.876 185.811 140.876H125.617C124.458 140.876 123.519 139.936 123.519 138.777V101.615C123.519 100.456 124.458 99.5167 125.617 99.5167H185.811M185.811 99.0144H125.617C124.183 99.0144 123.017 100.181 123.017 101.615V138.777C123.017 140.211 124.183 141.378 125.617 141.378H185.811C187.245 141.378 188.411 140.211 188.411 138.777V101.615C188.412 100.181 187.245 99.0144 185.811 99.0144Z'
        fill='white'
      />
      <path
        d='M185.811 140.875H125.617C124.458 140.875 123.519 139.935 123.519 138.776V105.112H187.91V138.776C187.91 139.935 186.97 140.875 185.811 140.875Z'
        fill='#C5B3DD'
      />
      <path
        d='M128.447 102.479C128.447 103.142 127.909 103.68 127.246 103.68C126.583 103.68 126.045 103.142 126.045 102.479C126.045 101.815 126.583 101.277 127.246 101.277C127.909 101.277 128.447 101.815 128.447 102.479Z'
        stroke='white'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path
        d='M133.103 102.479C133.103 103.142 132.566 103.68 131.902 103.68C131.239 103.68 130.701 103.142 130.701 102.479C130.701 101.815 131.239 101.277 131.902 101.277C132.566 101.277 133.103 101.815 133.103 102.479Z'
        stroke='white'
        strokeWidth='0.502'
        stroke-miterlimit='10'
      />
      <path d='M123.519 105.112H187.91' stroke='white' strokeWidth='0.502' stroke-miterlimit='10' />
      <path
        d='M178.876 132.837C175.673 129.29 171.951 127.535 170.059 127.963C167.275 128.592 167.781 135.698 167.859 138.551C166.514 136.996 164.848 135.72 162.996 134.829C161.6 134.158 160.012 133.699 158.508 134.066C157.004 134.432 155.679 135.847 155.855 137.385C152.351 132.173 147.515 127.865 141.933 124.985C138.406 123.165 128.815 119.381 127.173 123.308C125.372 127.616 135.588 140.875 135.588 140.875H185.105C185.105 140.875 181.77 136.041 178.876 132.837Z'
        fill='#A29DCE'
      />
      <path
        d='M117.003 94.9482C115.185 93.0436 113.439 89.3633 112.948 87.4004C112.517 85.6739 112.131 83.9065 111.316 82.3105C111.096 81.8801 110.152 80.8868 110.494 80.3701C111.185 79.3293 112.86 80.7004 113.297 81.3202C113.453 81.5421 114.03 82.4768 114.319 82.5314C114.608 82.5859 114.729 81.4668 114.765 80.9869C114.9 79.1422 114.909 77.1312 114.752 75.2648C114.591 73.3424 114.865 71.6557 115.468 71.5667C116.08 71.4767 116.048 71.8384 116.159 71.9589C116.257 71.3502 116.811 70.6283 117.169 70.8314C117.386 70.9549 117.465 71.2277 117.496 71.476C117.526 71.7243 117.674 72.1969 117.674 72.1969C117.674 72.1969 118.021 70.901 118.654 71.634C118.974 72.0044 119.461 73.9733 119.774 74.5984C119.742 74.1851 119.638 73.9549 119.771 73.4719C119.843 73.2099 119.991 72.9944 120.275 73.1323C120.442 73.2136 120.491 73.3792 120.549 73.5419C120.867 74.4241 121.648 75.8434 121.932 76.737C122.228 77.6687 122.524 78.6007 122.82 79.5324C123.377 81.2841 123.92 83.1274 124.319 84.9547C124.688 86.6451 126.044 90.8107 126.044 90.8107'
        fill='#A04B4B'
      />
      <path
        d='M116.142 72.0632C116.303 73.0656 116.67 74.3436 116.871 75.4798C117.159 77.109 117.289 78.6173 117.535 80.0521'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M117.761 72.228C117.954 73.0864 118.288 74.2755 118.512 75.2523C118.886 76.8849 119.161 78.348 119.483 79.7821'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M119.77 74.5707C120.245 76.1306 120.933 77.92 121.478 79.8942'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M114.5 82.4325C114.378 83.2564 114.317 84.1319 113.768 84.8518'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M178.528 140.876C177.884 139.155 177.195 137.347 176.227 135.77C175.259 134.193 173.994 132.749 172.379 131.761C171.655 131.317 170.871 130.971 170.089 130.626C167.988 129.698 165.887 128.77 163.785 127.841L153.472 123.818C152.833 123.225 152.195 122.633 151.558 122.04C150.327 120.893 149.098 119.743 147.88 118.582C147.833 118.537 147.786 118.493 147.739 118.448C138.404 109.537 131.461 99.5812 125.395 87.9623L114.501 92.7406C114.501 92.7406 119.213 108.797 123.69 115.613C129.604 124.617 136.444 132.807 139.535 135.4C140.087 137.253 140.718 139.081 141.434 140.876L178.528 140.876Z'
        fill='#FCDDD2'
      />
      <path
        d='M116.255 98.2633L127.94 92.6446'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M116.839 91.7154L120.779 100.265'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M120.542 93.5128C120.542 93.9388 120.196 94.2845 119.77 94.2845C119.344 94.2845 118.998 93.9391 118.998 93.5128C118.998 93.0867 119.343 92.741 119.77 92.741C120.196 92.7414 120.542 93.0867 120.542 93.5128Z'
        stroke='#D8A798'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M162.652 140.647C163.189 139.947 163.727 139.248 164.264 138.548C164.844 137.793 165.425 137.036 166.079 136.345C167.989 134.327 170.566 132.891 173.328 132.592'
        stroke='#D8A798'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M139.212 134.397C139.212 131.605 140.145 128.833 141.75 126.558C143.773 123.691 146.75 121.633 150.348 121.53'
        stroke='#D8A798'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M139.487 135.291C138.972 133.757 138.676 132.037 137.86 130.626'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M150.188 122.675L149.509 131.244C149.509 131.244 152.389 134.178 156.35 132.268C160.311 130.357 163.2 126.723 163.2 126.723L161.905 121.411'
        fill='#A04B4B'
      />
      <path
        d='M165.931 111.996C165.531 110.744 164.78 109.6 163.771 108.773C161.342 106.785 158.67 106.839 156.061 108.372C153.794 109.704 150.682 111.806 148.952 113.818C147.168 115.894 145.973 118.476 147.796 120.903C150.729 124.81 158.954 123.486 162.878 120.282C164.476 118.977 165.984 116.859 166.22 114.773C166.325 113.843 166.217 112.892 165.931 111.996Z'
        fill='#A04B4B'
      />
      <path
        d='M155.557 109.463C154.25 110.128 152.818 110.305 151.386 110.475C150.698 110.556 149.787 110.787 149.912 111.691C149.992 112.273 150.499 112.775 150.922 113.131'
        fill='#A04B4B'
      />
      <path
        d='M149.856 118.36C149.856 118.36 150.094 117.825 150.212 117.557C150.44 117.041 149.698 116.693 149.344 116.515C149.088 116.385 148.952 116.271 148.696 116.439C148.63 116.482 148.257 116.843 148.177 116.777C148.172 116.774 147.486 115.975 147.486 115.975C146.952 116.808 146.609 118.39 146.685 119.328C146.762 120.267 147.125 121.2 147.796 121.861C148.065 122.126 148.487 122.508 148.811 122.703C151.512 124.327 154.879 124.204 157.816 123.062C158.723 122.71 159.606 122.239 160.267 121.524C151.275 121.394 149.856 118.36 149.856 118.36Z'
        fill='#1E1611'
      />
      <path
        d='M160.579 117.759C160.539 117.75 160.499 117.742 160.459 117.736C159.859 117.636 159.265 117.724 158.673 117.53C158.197 117.373 157.753 117.077 157.492 116.65C157.183 116.144 157.607 115.849 158.019 115.622C158.628 115.286 159.221 114.908 159.717 114.42C160.532 113.617 160.961 112.467 160.608 111.346C160.224 110.13 159.027 109.416 158.099 108.646C157.204 107.904 156.06 106.748 156.437 105.46C156.816 104.169 158.064 103.698 159.296 103.88C159.958 103.978 160.625 104.163 161.285 104.061C161.621 104.008 161.941 103.883 162.272 103.809C163.291 103.58 164.464 103.906 165.071 104.755C165.507 105.367 165.677 106.234 166.35 106.568C166.674 106.729 167.053 106.725 167.405 106.808C168.12 106.977 168.725 107.521 169.016 108.196C169.308 108.871 169.296 109.66 169.034 110.348C168.564 111.583 167.86 112.202 168.438 113.565C169.779 116.73 170.343 120.615 167.139 122.891C166.297 123.489 165.241 123.799 164.54 124.558C164.102 125.031 163.745 125.706 163.104 125.775C162.674 125.82 162.268 125.554 161.973 125.237C161.708 124.953 161.5 124.622 161.295 124.292C161.011 123.835 160.722 123.357 160.663 122.823C160.58 122.06 160.976 121.337 161.336 120.659C161.675 120.02 162.357 118.694 161.55 118.166C161.272 117.983 160.915 117.832 160.579 117.759Z'
        fill='#1E1611'
      />
      <path
        d='M158.601 110.845C158.399 110.232 158.031 109.624 157.463 109.9C157.321 109.969 157.238 110.126 157.216 110.282C157.194 110.438 157.222 110.596 157.251 110.751C157.385 111.478 157.526 112.224 157.919 112.849C157.999 112.975 158.093 113.099 158.226 113.166C159.117 113.613 158.716 111.195 158.601 110.845Z'
        fill='#1E1611'
      />
      <path
        d='M152.976 114.989L150.457 114.418C150.457 114.418 150.21 116.578 151.281 116.792C152.351 117.006 152.976 114.989 152.976 114.989Z'
        fill='white'
      />
      <path
        d='M150.306 112.455C150.515 112.726 150.799 112.939 151.118 113.064'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M153.088 110.238C154.033 110.1 154.953 109.784 155.783 109.311'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M159.993 117.846C160.921 117.147 162.608 117.817 162.954 118.858C163.786 121.36 159.775 123.448 158.015 121.898C157.517 121.459 157.141 120.564 157.579 119.926'
        fill='#A04B4B'
      />
      <path
        d='M161.507 120.224L158.67 119.741'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M161.796 117.822C161.229 117.607 160.591 117.573 159.991 117.725'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M157.643 119.953C157.326 120.494 157.42 121.16 157.765 121.664C158.392 122.58 159.91 122.584 160.825 122.192'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M155.962 112.919C155.603 113.179 155.162 113.181 154.976 112.925C154.79 112.668 154.93 112.249 155.289 111.989C155.648 111.729 156.09 111.727 156.276 111.984C156.461 112.241 156.321 112.66 155.962 112.919Z'
        fill='black'
      />
      <path
        d='M164.599 126.443C155.558 127.515 150.022 131.655 150.022 131.655L151.595 138.838C159.681 131.15 167.548 129.415 167.627 129.333L164.599 126.443Z'
        fill='#FCDDD2'
      />
      <path
        d='M149.76 127.065L146.355 129.251C146.355 129.251 145.77 135.36 146.888 138.609L150.022 131.654L149.76 127.065Z'
        fill='#FCDDD2'
      />
      <path
        d='M150.022 131.654L151.595 138.837C159.681 131.149 167.548 129.414 167.627 129.332'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M149.76 127.065L146.355 129.251C146.355 129.251 145.77 135.36 146.888 138.609L150.022 131.654'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M116.207 107.642C117.121 110.89 118.474 114.014 120.22 116.901'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M116.506 113.221C117.08 115.31 117.768 117.366 118.566 119.38'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M172.326 117.599C172.375 119.087 171.797 120.551 170.911 121.748C170.025 122.945 168.846 123.897 167.602 124.715'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
      <path
        d='M171.314 124.662C172.561 123.955 173.624 122.929 174.375 121.709'
        stroke='black'
        strokeWidth='0.334667'
        stroke-miterlimit='10'
      />
    </svg>
  );
};

export default TeamBuildIcon;
